import { motion } from 'framer-motion';
import { fadeUp, staggeredFadeIn } from '../../utils/animations';
import {
    Clock, BarChart3, AlertTriangle, TrendingUp, ShieldAlert, MessageSquare,
} from 'lucide-react';

const auditItems = [
    { icon: Clock, title: 'Hours Worked vs. Hours Expected', body: "Are they putting in the time you're paying for?" },
    { icon: BarChart3, title: 'Task Distribution', body: 'Is time being spent on the right priorities, or is low-value work eating the day?' },
    { icon: AlertTriangle, title: 'Idle Time and Gaps', body: 'Are there unexplained gaps or periods of inactivity?' },
    { icon: TrendingUp, title: 'Efficiency Trends', body: 'Is the same task taking longer than it should? Are things improving month over month?' },
    { icon: ShieldAlert, title: 'Accountability Red Flags', body: 'Patterns that suggest disengagement, distraction, or declining performance.' },
    { icon: MessageSquare, title: 'Coaching Opportunities', body: 'Specific areas where a conversation or process adjustment would improve output.' },
];

export function AuditItems() {
    return (
        <section className="bg-[#F8F9FA] py-24 md:py-32" data-testid="what-we-look-for">
            <div className="max-w-5xl mx-auto px-6 lg:px-12">
                <motion.div {...fadeUp} className="mb-14">
                    <h2 className="font-montserrat font-bold text-3xl md:text-4xl text-navy-900 tracking-tight">
                        Every Audit Covers the Same Ground.
                    </h2>
                </motion.div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                    {auditItems.map((item, i) => (
                        <motion.div
                            key={item.title}
                            {...staggeredFadeIn(i * 0.08)}
                            className="flex items-start gap-4 bg-white border border-gray-100 rounded-sm p-6 shadow-sm hover:shadow-md transition-all duration-300"
                            data-testid={`audit-item-${i}`}
                        >
                            <div className="w-10 h-10 rounded-sm bg-navy-900 flex items-center justify-center flex-shrink-0">
                                <item.icon size={18} className="text-gold-400" strokeWidth={1.5} />
                            </div>
                            <div>
                                <h3 className="font-montserrat font-bold text-sm text-navy-900 mb-1">{item.title}</h3>
                                <p className="text-[#6B7280] text-sm leading-relaxed">{item.body}</p>
                            </div>
                        </motion.div>
                    ))}
                </div>

                <motion.div {...fadeUp} className="mt-10 rounded-sm overflow-hidden border border-gray-200 shadow-md" data-testid="screenshot-1">
                    <img
                        src="https://customer-assets.emergentagent.com/job_01a94bc3-1239-473e-9729-85c2afc85aa9/artifacts/sdfi4x54_image.png"
                        alt="ScreenshotMonitoring.com - Timeclock activity log showing periodic screenshots of VA work throughout the day"
                        className="w-full h-auto"
                    />
                </motion.div>
            </div>
        </section>
    );
}
